import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "promote-demote-students",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "promote-demote-students" */ "./components"),
      import(
        /* webpackChunkName: "promote-demote-students" */ "./modules/PromoteDemoteStudentsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const key = importedModule1.NAME;
      injectReducer(store, {
        key,
        reducer,
      });
      return component;
    })
  ),
});
